<template>
  <section>
    <Toolbar />
    <div
      class="
        d-flex
        flex-column
        justify-center
        ma-0
        pa-0
        mt-md-5 mt-lg-5 mt-xl-5
        mx-3
      "
    >
      <v-row justify="center" class="ma-0 pa-0 mt-2" v-if="errorFoto">
        <v-chip class="ma-2" color="red" text-color="white">
          Ocurrio un error intenta capturar nuevamente
        </v-chip>
      </v-row>

      <v-row
        justify="center"
        class="ma-0 pa-0 mt-2"
        v-if="
          (consumiendoInsertaDocumentos ||
            consumiendoActualizaEstatusSolicitud ||
            cargandoDocumentos) &&
          !errorFoto
        "
      >
        <v-chip class="ma-2" color="green" text-color="white">
          <v-progress-circular
            indeterminate
            color="white"
          ></v-progress-circular>
          Enviando tu documento...
        </v-chip>
      </v-row>

      <v-row justify="center" class="ma-0 pa-0 mt-2">
        <v-col cols="10" class="ma-0 pa-0">
          <h2 class="texto-titulo text-center font-weight-bold" ref="pagina">
            Captura: {{ documentoSeleccionado.TituloDocumento }}
          </h2>
        </v-col>
      </v-row>

      <v-row justify="center" class="ma-0 pa-0 mt-6 mx-3">
        <v-col
          cols="12"
          class="ma-0 pa-0 text-body-2 grey--text text--darken-2"
        >
          <v-card class="mx-auto rounded-lg" max-width="450" elevation="2">
            <v-list disabled dense>
              <v-subheader class="text-subtitle-1 grey--text text--darken-2">
                Requisitos:
              </v-subheader>

              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(requisito, i) in requisitosActuales"
                  :key="i"
                >
                  <v-list-item-icon class="my-0 mr-2">
                    <v-icon color="primary">mdi-check-circle</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content
                    class="pt-1 pl-0 pr-0 pb-0 align-self-start"
                  >
                    <v-list-item-title v-text="requisito"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-col>
      </v-row>

      <v-row
        v-if="$store.getters['credito/obtenerObservacionesDevolucion'] != ''"
        justify="center"
        class="ma-0 pa-0 mx-3 mt-3"
      >
        <v-col cols="12" class="ma-0 pa-0">
          <v-alert
            dense
            text
            type="info"
            :icon="false"
            class="text-center font-weight-black ma-0"
          >
            <p>Observaciones:</p>
            <p>
              {{ $store.getters['credito/obtenerObservacionesDevolucion'] }}
            </p>
          </v-alert>
        </v-col>
      </v-row>

      <template v-if="esMobile">
        <v-row justify="center">
          <v-col cols="10">
            <v-card
              color="grey darken-1"
              elevation="5"
              class="d-flex flex-row justify-center mb-3"
              v-if="imagen"
            >
              <v-img v-if="!imagen" :src="rutaActual"></v-img>
              <v-card v-else>
                <v-img height="250px" :src="imagen"></v-img>
              </v-card>
            </v-card>
            <v-img v-if="!imagen" :src="rutaActual"></v-img>
          </v-col>
        </v-row>

        <v-row justify="center" class="ma-0 pa-0">
          <v-col cols="12" class="ma-0 pa-0">
            <input
              type="file"
              name="foto"
              id="foto"
              accept="image/*"
              capture="environment"
              @change="cargarFoto"
              ref="inputFotografia"
              hidden
            />

            <div
              v-if="!imagen"
              class="d-flex flex-column justify-center align-center"
            >
              <!-- Diseño estándar para documentos NO opcionales -->
              <template v-if="!esComprobanteDomicilio">
                <v-btn
                  @click="$refs.inputFotografia.click()"
                  fab
                  color="primary"
                  x-large
                  class="mt-5"
                >
                  <v-icon>mdi-camera</v-icon>
                </v-btn>
              </template>

              <!-- Diseño mejorado para Comprobante de Domicilio (opcional) -->
              <template v-else>
                <template
                  v-if="!$store.getters['credito/obtenerAplicaDevolucion']"
                >
                  <v-alert
                    dense
                    color="teal lighten-5"
                    class="alerta-documento-opcional mb-0 mt-3 px-4 py-3"
                    style="border-left: 4px solid #009688; border-radius: 10px"
                  >
                    <div class="d-flex align-start">
                      <v-icon color="teal" class="mr-2 mt-1" small
                        >mdi-information-outline</v-icon
                      >
                      <div>
                        <div
                          class="
                            font-weight-bold
                            teal--text
                            text--darken-1
                            mb-1
                          "
                          style="font-size: 13px"
                        >
                          ¿En este momento no tienes el documento a la mano?
                        </div>
                        <div
                          class="
                            texto-documento-opcional
                            grey--text
                            text--darken-2
                          "
                        >
                          Puedes seguir avanzando con tu solicitud,
                          <span class="font-weight-bold">
                            pero para que podamos autorizar tu crédito será
                            necesario que lo envíes.
                          </span>
                        </div>
                      </div>
                    </div>
                  </v-alert>

                  <v-btn
                    @click="$refs.inputFotografia.click()"
                    color="primary"
                    large
                    block
                    class="mt-4 tomar-foto-btn"
                    elevation="2"
                  >
                    <v-icon left>mdi-camera-outline</v-icon>
                    Tomar foto del comprobante
                  </v-btn>

                  <div class="separador-opcional my-3">
                    <v-divider></v-divider>
                    <span class="separador-texto grey--text text--darken-1"
                      >¿NO LO TIENES AHORA?</span
                    >
                    <v-divider></v-divider>
                  </div>

                  <v-btn
                    color="primary"
                    outlined
                    large
                    block
                    class="continuar-sin-subir-btn"
                    @click="cargarMasTarde"
                  >
                    Continuar sin subirlo ahora
                    <v-icon right>mdi-arrow-right</v-icon>
                  </v-btn>
                </template>

                <template v-else>
                  <v-btn
                    @click="$refs.inputFotografia.click()"
                    fab
                    color="primary"
                    x-large
                    class="mt-2"
                  >
                    <v-icon>mdi-camera</v-icon>
                  </v-btn>
                  <p class="texto-ayuda mt-3 mb-0">
                    Tomar foto del comprobante
                  </p>
                </template>
              </template>
            </div>

            <div class="d-flex flex-row justify-center align-center" v-else>
              <v-btn
                color="primary"
                text
                @click="$refs.inputFotografia.click()"
                plain
                ref="botonVolverACapturar"
              >
                Volver a capturar
              </v-btn>

              <v-btn
                color="primary"
                @click="siguiente"
                elevation="3"
                :loading="
                  (consumiendoInsertaDocumentos ||
                    consumiendoActualizaEstatusSolicitud ||
                    cargandoDocumentos) &&
                  !errorFoto
                "
                :disabled="
                  (consumiendoInsertaDocumentos ||
                    consumiendoActualizaEstatusSolicitud ||
                    cargandoDocumentos) &&
                  !errorFoto
                "
              >
                Continuar
                <v-icon right light>mdi-arrow-right</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="9" class="text-right align-center" style="display: grid">
            ¿Necesitas ayuda? Escribenos
          </v-col>
          <v-col cols="3">
            <v-fab-transition>
              <v-btn color="primary" @click="whats" fab right>
                <v-icon>mdi-whatsapp</v-icon>
              </v-btn>
            </v-fab-transition>
          </v-col>
        </v-row>
      </template>

      <template v-else>
        <v-row justify="center" class="ma-0">
          <v-col cols="10">
            <v-card
              v-if="!esCamaraDesktopActiva"
              color="grey darken-1"
              elevation="5"
              class="foto-cargada-desktop d-flex flex-row justify-center"
            >
              <v-img v-if="!imagen" :src="rutaActual"></v-img>
              <v-card v-else>
                <v-img height="300px" :src="imagen"></v-img>
              </v-card>
            </v-card>
          </v-col>
        </v-row>

        <v-row justify="center" class="ma-0 pa-0">
          <v-col cols="12" class="ma-0 pa-0">
            <v-easy-camera
              v-if="esCamaraDesktopActiva"
              @input="cargarFotoDesktop"
              v-model="imagen"
              ref="camaraDesktop"
            ></v-easy-camera>

            <div
              v-if="!imagen"
              class="d-flex flex-column justify-center align-center my-5"
            >
              <!-- Diseño estándar para documentos NO opcionales -->
              <template v-if="!esComprobanteDomicilio">
                <v-btn
                  @click="tomarFotoDesktop(false)"
                  fab
                  color="primary"
                  x-large
                >
                  <v-icon>mdi-camera</v-icon>
                </v-btn>
              </template>

              <!-- Diseño mejorado para Comprobante de Domicilio (opcional) -->
              <template v-else>
                <template
                  v-if="!$store.getters['credito/obtenerAplicaDevolucion']"
                >
                  <v-alert
                    dense
                    color="teal lighten-5"
                    class="
                      alerta-documento-opcional
                      alerta-documento-opcional-desktop
                      mb-0
                      mt-1
                      px-4
                      py-3
                    "
                    style="border-left: 4px solid #009688; border-radius: 10px"
                  >
                    <div class="d-flex align-start">
                      <v-icon color="teal" class="mr-2 mt-1" small
                        >mdi-information-outline</v-icon
                      >
                      <div>
                        <div
                          class="
                            font-weight-bold
                            teal--text
                            text--darken-1
                            mb-1
                          "
                          style="font-size: 13px"
                        >
                          ¿En este momento no tienes el documento a la mano?
                        </div>
                        <div
                          class="
                            texto-documento-opcional
                            grey--text
                            text--darken-2
                          "
                        >
                          Puedes seguir avanzando con tu solicitud,
                          <span class="font-weight-bold">
                            pero para que podamos autorizar tu crédito será
                            necesario que lo envíes.
                          </span>
                        </div>
                      </div>
                    </div>
                  </v-alert>

                  <v-btn
                    @click="tomarFotoDesktop(false)"
                    color="primary"
                    large
                    block
                    class="mt-4 tomar-foto-btn"
                    elevation="2"
                  >
                    <v-icon left>mdi-camera-outline</v-icon>
                    Tomar foto del comprobante
                  </v-btn>

                  <div class="separador-opcional my-3">
                    <v-divider></v-divider>
                    <span class="separador-texto grey--text text--darken-1"
                      >¿NO LO TIENES AHORA?</span
                    >
                    <v-divider></v-divider>
                  </div>

                  <v-btn
                    color="primary"
                    outlined
                    large
                    block
                    class="continuar-sin-subir-btn"
                    @click="cargarMasTarde"
                  >
                    Continuar sin subirlo ahora
                    <v-icon right>mdi-arrow-right</v-icon>
                  </v-btn>
                </template>

                <template v-else>
                  <v-btn
                    @click="tomarFotoDesktop(false)"
                    fab
                    color="primary"
                    x-large
                    class="mt-2"
                  >
                    <v-icon>mdi-camera</v-icon>
                  </v-btn>
                  <p class="texto-ayuda mt-3 mb-0">
                    Tomar foto del comprobante
                  </p>
                </template>
              </template>
            </div>

            <div
              class="d-flex flex-row justify-space-around align-center my-5"
              v-else
            >
              <v-btn
                color="primary"
                text
                @click="tomarFotoDesktop(true)"
                ref="botonVolverACapturar"
                plain
              >
                Volver a capturar
              </v-btn>

              <v-btn
                color="primary"
                @click="siguiente"
                elevation="3"
                :loading="
                  (consumiendoInsertaDocumentos ||
                    consumiendoActualizaEstatusSolicitud ||
                    cargandoDocumentos) &&
                  !errorFoto
                "
                :disabled="
                  (consumiendoInsertaDocumentos ||
                    consumiendoActualizaEstatusSolicitud ||
                    cargandoDocumentos) &&
                  !errorFoto
                "
              >
                Continuar
                <v-icon right light>mdi-arrow-right</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </template>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import EasyCamera from 'easy-vue-camera'
import Toolbar from '@/components/compartidos/Toolbar.vue'
import { InsertaDocumentosSolicitudMixin } from '@/mixins/personaDocumentos/InsertaDocumentosSolicitud.mixin'
import { ActualizaEstatusSolicitudMixin } from '@/mixins/credito/ActualizaEstatusSolicitud.mixin'
import {
  convertirArchivoABase64,
  comprimirImagen,
  ALERTA_ERROR,
  detectarOrientacionImagen,
} from '../../utilidades/utilidades.js'
import CreditoService from '@/servicios/credito'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'
import { NavegacionCorreoMixin } from '@/mixins/credito/NavegacionCorreo.mixin'

export default {
  components: { Toolbar, 'v-easy-camera': EasyCamera },
  mixins: [
    InsertaDocumentosSolicitudMixin,
    ActualizaEstatusSolicitudMixin,
    InsertaLogMixin,
    NavegacionCorreoMixin,
  ],
  name: 'CargaDocumentos',
  created() {
    this.$store.commit('ESTABLECER_LAYOUT', 'Layout')
    this.$store.dispatch('personaDocumentos/restablecerDocumentos')
    this.documentos = this.$store.getters['personaDocumentos/obtenerDocumentos']
    this.documentoSeleccionado = this.documentos[0] || {}
    this.folioDigital = this.$store.getters['credito/obtenerFolioDigital']

    if (Number(this.documentoSeleccionado.idDocumento) === 8) {
      if (this.$store.getters['credito/obtenerAplicaDevolucionMonto']) {
        this.$router.push('/confirmacion')
      } else {
        this.$router.push('/CanvasFirmaUsuario')
      }
      return
    }
  },
  data: () => {
    return {
      imagen: null,
      imagenDesktop: null,
      esCamaraDesktopActiva: false,
      documentos: [],
      documentoSeleccionado: {},
      id_solicitud: null,
      requisitos: ['Imagen clara', 'Datos visibles', 'Ser vigente'],
      rutaActual: '@/assets/gifs/001 -- INE FRONTAL.gif',
      cargandoDocumentos: false,
      folioDigital: 0,
      errorFoto: false,
    }
  },
  methods: {
    whats() {},
    resetVistaDocumento() {
      this.imagen = null
      this.imagenDesktop = null
      this.esCamaraDesktopActiva = false
      window.scrollTo(0, 0)
    },
    navegarDespuesDeDocumentos() {
      if (this.$store.getters['credito/obtenerAplicaDevolucion'] == 1) {
        if (this.$store.getters['credito/obtenerAplicaDevolucionMonto']) {
          this.$router.push('/confirmacion')
        } else {
          this.id_solicitud = this.$store.getters['credito/obtenerIdSolicitud']
          this.actualizaEstatusSolicitud(this.id_solicitud)
          this.cargandoDocumentos = true
        }
      } else {
        this.navegarACorreoOSiguiente()
      }
    },
    continuarDespuesDeDocumento() {
      this.documentos =
        this.$store.getters['personaDocumentos/obtenerDocumentos']

      if (
        this.$store.getters['personaDocumentos/obtenerSiguienteDocumento'] < 0
      ) {
        this.navegarDespuesDeDocumentos()
        return
      }

      this.documentoSeleccionado =
        this.documentos[
          this.$store.getters['personaDocumentos/obtenerSiguienteDocumento']
        ]

      if (
        Number(this.documentoSeleccionado.idDocumento) === 4 &&
        this.$store.getters['persona/obtenerDomicilioCoincideIne'] === true
      ) {
        this.$store.dispatch('personaDocumentos/omitirDocumento')
        this.continuarDespuesDeDocumento()
        return
      }

      if (Number(this.documentoSeleccionado.idDocumento) === 8) {
        if (this.$store.getters['credito/obtenerAplicaDevolucionMonto']) {
          this.$router.push('/confirmacion')
        } else {
          this.$router.push('/CanvasFirmaUsuario')
        }
        return
      }

      this.resetVistaDocumento()
      this.actualizaGif(this.documentoSeleccionado.idDocumento)
    },
    cargarMasTarde() {
      if (!this.esComprobanteDomicilio) {
        return
      }

      this.InsertaLog({
        notas:
          this.documentoSeleccionado.TituloDocumento + ' - cargar más tarde',
      })

      this.errorFoto = false
      this.$store.dispatch('personaDocumentos/omitirDocumento')
      this.continuarDespuesDeDocumento()
    },
    async cargarFoto(e) {
      let archivos = e.target.files || e.dataTransfer.files
      if (!archivos.length) {
        return
      }

      let v = this

      detectarOrientacionImagen(archivos[0], async function (orientacion) {
        comprimirImagen(
          archivos[0],
          orientacion,
          async function (imagenComprimida) {
            let imagenBase64 = await convertirArchivoABase64(imagenComprimida)
            v.$store.dispatch('personaDocumentos/insertarDocumentos', {
              imagenBase64,
              id: v.documentoSeleccionado.idDocumento,
              folioDigital: v.folioDigital,
            })
            v.imagen = v.obtenerImagenBase64(
              v.documentoSeleccionado.idDocumento
            )
          }
        )
      })

      this.$gtag.event('cargaDocumento', {
        event_category: 'change_in_window',
        event_label: 'Sube fotografia',
        value: v.documentoSeleccionado.TituloDocumento,
      })
    },
    siguiente() {
      this.InsertaLog({ notas: this.documentoSeleccionado.TituloDocumento })

      const documentosAEnviar =
        this.$store.getters[
          'personaDocumentos/obtenerDocumentosSolicitudDigital'
        ]

      if (!documentosAEnviar.archivo) {
        this.resetVistaDocumento()
        this.actualizaGif(this.documentoSeleccionado.idDocumento)
        return
      }

      this.cargandoDocumentos = true

      CreditoService.insertaDocumentos(documentosAEnviar)
        .then((result) => {
          this.cargandoDocumentos = false
          this.errorFoto = false

          if (result.data.Modelo) {
            this.$store.dispatch('personaDocumentos/siguienteDocumento')
            this.continuarDespuesDeDocumento()
          } else {
            this.errorFoto = true
            this.resetVistaDocumento()
            this.actualizaGif(this.documentoSeleccionado.idDocumento)
            this.$store.dispatch('alerta/enviarAlertaError', {
              mensaje:
                'No se pudo enviar tu documento, por favor capturalo de nuevo',
              tiempo: ALERTA_ERROR.tiempo,
              visibilidad: ALERTA_ERROR.visibilidad,
            })
            this.$gtag.event('Error en documentos', {
              event_category: 'change_in_window',
              event_label:
                'Documento: ' + this.documentoSeleccionado.idDocumento,
              value: result.data.Mensaje
                ? result.data.Mensaje
                : result.data.mensaje
                ? result.data.mensaje
                : 'No pude optener mensaje del error',
            })
            this.InsertaLog({
              exception_error:
                'No se pudo enviar tu documento, por favor capturalo de nuevo',
              notas: result.data.Mensaje ? result.data.Mensaje : '',
            })
          }
        })
        .catch((error) => {
          console.error(error)
          this.cargandoDocumentos = false
          this.errorFoto = true
          this.resetVistaDocumento()
          this.actualizaGif(this.documentoSeleccionado.idDocumento)
          this.$store.dispatch('alerta/enviarAlertaError', {
            mensaje:
              'No se pudo enviar tu documento, por favor capturalo de nuevo',
            tiempo: ALERTA_ERROR.tiempo,
            visibilidad: ALERTA_ERROR.visibilidad,
          })
          this.$gtag.event('Error en documentos', {
            event_category: 'change_in_window',
            event_label: 'Documento: ' + this.documentoSeleccionado.idDocumento,
            value: error ? error : 'No pude optener mensaje del error',
          })
        })

      this.$gtag.event('siguienteDocumento', {
        event_category: 'change_in_window',
        event_label: 'Tomo siguiente documento',
        value: 1,
      })
    },
    cargarFotoDesktop(imagenBase64) {
      this.folioDigital = this.$store.getters['credito/obtenerFolioDigital']
      this.$store.dispatch('personaDocumentos/insertarDocumentos', {
        imagenBase64,
        id: this.documentoSeleccionado.idDocumento,
        folioDigital: this.folioDigital,
      })
      this.imagen = this.obtenerImagenBase64(
        this.documentoSeleccionado.idDocumento
      )
      this.$refs.camaraDesktop.close()
      this.esCamaraDesktopActiva = false
    },
    tomarFotoDesktop(volverACapturar) {
      if (volverACapturar) {
        this.imagen = null
      }
      if (this.esCamaraDesktopActiva === false) {
        this.esCamaraDesktopActiva = true
        return
      } else {
        this.$refs.camaraDesktop.snap()
        this.$refs.camaraDesktop.close()
        this.esCamaraDesktopActiva = false
      }
    },
    async actualizarDocumentos() {
      this.id_solicitud = this.$store.getters['credito/obtenerIdSolicitud']
      let documentos = this.documentos
      const id_solicitud = this.id_solicitud
      const promesas = []

      for (const documento of documentos) {
        documento.id_solicitud = id_solicitud
        let documentoArr = []
        documentoArr.push(documento)
        const resultado = CreditoService.insertaDocumentos(documentoArr)
        promesas.push(resultado)
      }

      const resultados = await Promise.all(promesas)
      let archivosCargadosCorrectamente = true

      for (const resultado of resultados) {
        if (resultado.data.Codigo != 200) {
          console.error('Ha ocurrido un error al cargar documentos')
          archivosCargadosCorrectamente = false
          this.cargandoDocumentos = false
          return
        }
      }

      if (archivosCargadosCorrectamente) {
        this.actualizaEstatusSolicitud(this.id_solicitud)
      } else {
        console.error('Ha ocurrido un error al cargar documentos')
      }
    },
    postActualizaEstatusSolicitud() {
      this.cargandoDocumentos = false
      this.$router.push('terminacionActualizacion')
    },
    errorInsertaDocumentosSolicitud(mensaje) {
      console.error(mensaje)
      this.$store.dispatch('alerta/enviarAlertaError', {
        mensaje: mensaje,
        tiempo: ALERTA_ERROR.tiempo,
        visibilidad: ALERTA_ERROR.visibilidad,
      })
    },
    errorActualizaEstatusSolicitud(mensaje) {
      this.$store.dispatch('alerta/enviarAlertaError', {
        mensaje: mensaje,
        tiempo: ALERTA_ERROR.tiempo,
        visibilidad: ALERTA_ERROR.visibilidad,
      })
    },
    actualizaGif(id) {
      this.rutaActual = this.obtenerGifsDocs(id)
    },
  },
  computed: {
    esMobile() {
      var isMobile = false
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
          navigator.userAgent
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw(n|u)|c55\/|capi|ccwa|cdm|cell|chtm|cldc|cmd|co(mp|nd)|craw|da(it|ll|ng)|dbte|dcs|devi|dica|dmob|do(c|p)o|ds(12|d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(|_)|g1 u|g560|gene|gf5|gmo|go(\.w|od)|gr(ad|un)|haie|hcit|hd(m|p|t)|hei|hi(pt|ta)|hp( i|ip)|hsc|ht(c(| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i(20|go|ma)|i230|iac( ||\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|[a-w])|libw|lynx|m1w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|mcr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|([1-8]|c))|phil|pire|pl(ay|uc)|pn2|po(ck|rt|se)|prox|psio|ptg|qaa|qc(07|12|21|32|60|[2-7]|i)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h|oo|p)|sdk\/|se(c(|0|1)|47|mc|nd|ri)|sgh|shar|sie(|m)|sk0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h|v|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl|tdg|tel(i|m)|tim|tmo|to(pl|sh)|ts(70|m|m3|m5)|tx9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas|your|zeto|zte/i.test(
          navigator.userAgent.substr(0, 4)
        )
      ) {
        isMobile = true
      }
      return isMobile
    },
    esComprobanteDomicilio() {
      return (
        this.documentoSeleccionado &&
        Number(this.documentoSeleccionado.idDocumento) === 4
      )
    },
    requisitosActuales() {
      if (this.esComprobanteDomicilio) {
        return [
          'Imagen clara y datos visibles',
          'Comprobante no mayor a 3 meses',
        ]
      }

      return this.requisitos
    },
    ...mapGetters({
      obtenerImagenBase64: 'personaDocumentos/obtenerImagenBase64',
      obtenerGifsDocs: 'personaDocumentos/obtenerGifsDocumentos',
    }),
  },
  mounted() {
    if (
      !this.documentoSeleccionado ||
      !this.documentoSeleccionado.idDocumento
    ) {
      return
    }

    this.siguiente()
    this.imagen = this.obtenerImagenBase64(
      this.documentoSeleccionado.idDocumento
    )
  },
}
</script>

<style>
.imagen-zoom {
  max-width: 100%;
  max-height: 250px !important;
  height: 250px !important;
  object-fit: cover;
}

.foto-cargada-desktop {
  height: 300px;
}

.v-chip .v-chip__content {
  height: auto !important;
}

.alerta-documento-opcional {
  border-radius: 12px;
  max-width: 430px;
}

.alerta-documento-opcional-desktop {
  width: 430px;
}

.texto-documento-opcional {
  font-size: 14px;
  line-height: 1.4;
}

.continuar-sin-subir-btn {
  max-width: 430px;
  width: 100%;
  border-radius: 8px !important;
  font-weight: 600 !important;
  letter-spacing: 0.3px !important;
}

.tomar-foto-btn {
  max-width: 430px;
  width: 100%;
  border-radius: 8px !important;
  font-weight: 500 !important;
}

.separador-opcional {
  display: flex;
  align-items: center;
  max-width: 430px;
  width: 100%;
  gap: 10px;
}

.separador-texto {
  white-space: nowrap;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.8px;
  padding: 0 4px;
}

.texto-ayuda-opcional {
  font-size: 12px;
  color: #757575;
  text-align: center;
  max-width: 380px;
}
</style>
